import { ThunkType } from "../../../../core/store/reducers";
import { setDividends } from "../dividendsDataSlice";
import { setDividendsIndex } from "../dividendsUXSlice";
import { PageIndex } from "../../../models";
import { getDividendsThunk } from "./getDividendsThunk";

export const loadDividends = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	const { pageNumber, itemsPerPage } = store.ux.reports.dividends.index;
	const { filter } = store.ux.reports.dividends ;

	const dividnesData = await dispatch(getDividendsThunk(pageNumber, itemsPerPage, filter));

	if (dividnesData) {
		dispatch(setDividends(dividnesData));
	}
};

export const setDividendsIndexThunk = (index: PageIndex): ThunkType => dispatch => {
	dispatch(setDividendsIndex(index));
	dispatch(loadDividends());
};
